var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFindStore = function SvgFindStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 304c-114.875 0-208 93.125-208 208s93.125 208 208 208 208-93.125 208-208c-.182-114.802-93.198-207.818-207.982-208H512zm0 384c-97.202 0-176-78.798-176-176s78.798-176 176-176 176 78.798 176 176c-.182 97.129-78.871 175.818-175.983 176H512z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 416c-53.019 0-96 42.981-96 96s42.981 96 96 96 96-42.981 96-96-42.981-96-96-96zm0 160c-35.346 0-64-28.654-64-64s28.654-64 64-64c35.346 0 64 28.654 64 64 0 35.346-28.654 64-64 64zM496 848h32V720h-32v128zM176 496v32h128v-32H176zM528 176h-32v128h32V176zM720 496v32h128v-32H720z"
  })));
};
export default SvgFindStore;